import { replaceWindowHistory } from "@utils/window-history";

import formatTextUpperCasefirst from "@utils/format-text-upper-casefirst";

export default {
  data() {
    return {
      visible: false,
      name: 'dialog',
      isQuerySet: false
    }
  },
  watch: {
    visible(newValue, oldValue) {
      replaceWindowHistory({
        query: {
          [`dialog${formatTextUpperCasefirst(this.name)}Visible`]: this.isQuerySet && newValue
            ? newValue
            : ''
        }
      });
    }
  },
  computed: {
    dialog2MixinVisible: {
      get() {
        return this.visible
      },
      set(value) {
        this.visible = value
      }
    },
  },
  methods: {
    $Dialog2MixinOnClose() {
      this.visible = true
    },
    $Dialog2MixinOnDestroy() {
      this.$destroy();
    },
  },
}
